import { CognitoUserPool } from 'amazon-cognito-identity-js';

const UserPoolId = process.env.REACT_APP_USER_POOL_ID;
const ClientId = process.env.REACT_APP_CLIENT_ID;

if (!UserPoolId || !ClientId) {
  throw new Error(
    'Missing Cognito configuration. Please ensure REACT_APP_USER_POOL_ID and REACT_APP_CLIENT_ID are set in your .env file and restart the development server.'
  );
}

const poolData = {
  UserPoolId,
  ClientId,
};

export const userPool = new CognitoUserPool(poolData);
